import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { api, copyText, API } from "@/lib/api";
import { toast } from "sonner";
import { X, ShareNetwork, ArrowSquareOut } from "@phosphor-icons/react";
import { BoxScoreView } from "@/components/BoxScoreView";

export function BoxScoreModal({ gameId, onClose }) {
  const [box, setBox] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/games/${gameId}/boxscore`).then((r) => setBox(r.data)).catch(() => setError(true));
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [gameId, onClose]);

  const recapUrl = `${window.location.origin}/recap/${gameId}`;
  const shareUrl = `${API}/recap/${gameId}`;
  const copyLink = async () => {
    if (await copyText(shareUrl)) toast.success("Recap link copied — share it anywhere!");
    else toast.error("Could not copy link");
  };

  return createPortal(
    <div className="fixed inset-0 z-[60] flex items-start sm:items-center justify-center p-3 sm:p-6 bg-black/80 backdrop-blur-sm overflow-y-auto" onClick={onClose}>
      <div className="bg-[#121212] border border-white/10 w-full max-w-3xl my-4" onClick={(e) => e.stopPropagation()} data-testid="boxscore-modal">
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10 sticky top-0 bg-[#121212] z-10">
          <h3 className="font-display text-2xl uppercase">Box Score</h3>
          <div className="flex items-center gap-2">
            <button onClick={copyLink} data-testid="boxscore-share" className="flex items-center gap-1.5 border border-[#FF5722]/50 text-[#FF5722] hover:bg-[#FF5722]/10 uppercase tracking-wide text-xs font-bold px-3 py-1.5 transition-all duration-200">
              <ShareNetwork size={15} weight="bold" /> Share
            </button>
            <a href={recapUrl} target="_blank" rel="noopener noreferrer" data-testid="boxscore-open-recap" className="flex items-center gap-1.5 border border-white/15 text-white/70 hover:text-white uppercase tracking-wide text-xs font-bold px-3 py-1.5 transition-all duration-200">
              <ArrowSquareOut size={15} /> Recap
            </a>
            <button onClick={onClose} data-testid="boxscore-close" className="text-white/50 hover:text-white"><X size={22} /></button>
          </div>
        </div>
        <div className="p-5">
          {error && <p className="text-white/40 py-8 text-center">Could not load the box score.</p>}
          {!error && !box && <p className="text-white/40 py-8 text-center">Loading box score…</p>}
          {box && <BoxScoreView box={box} />}
        </div>
      </div>
    </div>,
    document.body
  );
}
